import {FinalCertificate} from './flex-final-certificate';
import {ConfigService} from '../../../../../service/config.service';

export class FlexFinalCertificateViewModel {
    public readonly downloadUrl: string;
    public readonly financialYear: string;
    public readonly statementOfReturnDownloadUrl: string;

    constructor(downloadUrl: string, financialYear: string, statementOfReturnDownloadUrl: string) {
        this.downloadUrl = downloadUrl;
        this.financialYear = financialYear;
        this.statementOfReturnDownloadUrl = statementOfReturnDownloadUrl;
    }

    public static from(certificate: FinalCertificate, profileId: string, token: string): FlexFinalCertificateViewModel {
        const downloadUrl = certificate.source ? certificate.source : this.createFileManagementServiceUrl(certificate.fileId, profileId, token);
        const statementOfReturnDownloadUrl = certificate.statementOfReturnsFileId ? this.createFileManagementServiceUrl(certificate.statementOfReturnsFileId, profileId, token) : null;
        return new FlexFinalCertificateViewModel(downloadUrl, certificate.financialYear, statementOfReturnDownloadUrl);
    }

    public static createFileManagementServiceUrl(fileId: string, profileId: any, token: any) {
        return `${ConfigService.getFileManagementServiceUrl()}/file/${fileId}?userId=${profileId}&token=${token}`;
    }
}
